export const tableRow = (label: string, data: string[] | string | undefined, asHeader: boolean = false, labelBold: boolean = true) => {
  if (typeof data === 'string') {
    return {
      columns: [
        {
          width: 90,
          alignment: 'left',
          margin: [0, 0, 0, 2],
          text: label,
          bold: labelBold
        },
        {
          width: '*',
          alignment: 'left',
          color: asHeader ? '#5C5C5C' : '#808285',
          margin: [0, 0, 0, 2],
          text: data,
          bold: asHeader
        }
      ]
    };
  }

  return (data ?? []).map((code, index) => {
    return {
      columns: [
        {
          text: index === 0 ? label : ''
        },
        {
          text: code
        }
      ]
    };
  });
};
